import { positiveNumberValidator } from "validators";
import * as yup from "yup";

const createWalletValidator = yup
  .object({
    bank: yup.string().required("Bank is required"),
    account: yup.string().required("Account is required"),
    balance: yup
      .string()
      .required("Wallet Balance is required")
      .test(
        "is-digit",
        "Wallet Balance must be number only",
        (value: any) => value.trim().length > 0 && !isNaN(Number(value))
      ),
  })
  .required();

export default createWalletValidator;

export const updateWalletBalanceValidator = yup
  .object({
    balance: yup
      .string()
      .required("Wallet Balance is required")
      .test(
        "is-digit",
        "Wallet Balance must be number only",
        (value: any) => value.trim().length > 0 && !isNaN(Number(value))
      )
      .test(
        "is-positive",
        "Wallet Balance must be positive",
        positiveNumberValidator
      ),
  })
  .required();

export const updateWalletValidator = yup
  .object({
    bank: yup.string().required("Bank is required"),
    account: yup.string().required("Account is required"),
  })
  .required();
